import { InscalarProvider as Provider } from '@ilg-core/inscalar-web/react'
import { PropsWithChildren } from 'react'

import type { InscalarConfig, LogAdapter } from '@ilg-core/inscalar-web'

const logAdapter: LogAdapter = {
    debug: (message: string, context) => {
        console.debug(message, context)
    },
    info: (message: string, context) => {
        console.info(message, context)
    },
    warn: (message: string, context) => {
        console.warn(message, context)
    },
    error: (message: string, context) => {
        console.error(message, context)
    },
}

const inscalarConfig: InscalarConfig = {
    projectId: process.env.NEXT_PUBLIC_INSCALAR_PROJECT_ID ?? '',
    apiKey: process.env.NEXT_PUBLIC_INSCALAR_API_KEY ?? '',
    environment:
        process.env.NEXT_PUBLIC_APP_ENV === 'production' ? 'prod' : 'test',
    apiBaseUrl: process.env.NEXT_PUBLIC_INSCALAR_API_BASE_URL ?? '',
    logAdapter,
    debug: process.env.NEXT_PUBLIC_APP_ENV !== 'production',
}

export const InscalarProvider = ({ children }: PropsWithChildren) => {
    return <Provider config={inscalarConfig}>{children}</Provider>
}
